export default __webpack_public_path__ + "static/media/love.c5a3b469.svg";